import { createReducer, on } from "@ngrx/store";
import { loadLedgersSuccess, loadLedgersFailure, addLedger, updateLedger, deleteLedger } from "./ledger.actions";

export interface LedgerState {
    ledgers: any[];
    lastUpdatedBy?: { id: number; source: 'http' | 'signalr' };
    error: string | null;
  }
  
  const initialState: LedgerState = {
    ledgers: [],
    error: null,
  };

  export const ledgerReducer = createReducer(
    initialState,
    on(loadLedgersSuccess, (state, { ledgers }) => ({
      ...state,
      ledgers,
      error: null
    })),
    on(loadLedgersFailure, (state, { error }) => ({
      ...state,
      error
    })),
    on(addLedger, (state, { ledger }) => ({
      ...state,
      ledgers: [...state.ledgers, ledger],
      error: null
    })),
    on(updateLedger, (state, { ledger, source }) => {
      if (state.lastUpdatedBy && state.lastUpdatedBy.id == ledger.ledgerId && state.lastUpdatedBy.source !== source) {
        return { ...state, lastUpdatedBy: undefined };
      }

      const index = state.ledgers.findIndex(l => l.ledgerId === ledger.ledgerId);
      if (index === -1) return { ...state, lastUpdatedBy: undefined }; // Ledger not found, return state as is
      const updatedLedgers = [
        ...state.ledgers.slice(0, index),
        { ...state.ledgers[index], ...ledger },
        ...state.ledgers.slice(index + 1)
      ];
      return {
        ...state,
        ledgers: updatedLedgers,
        lastUpdatedBy: { id: ledger.ledgerId, source },
        error: null
      };
    }),
    on(deleteLedger, (state, { ledgerId, source }) => {
      if (state.lastUpdatedBy && state.lastUpdatedBy.id == ledgerId && state.lastUpdatedBy.source !== source) {
        return { ...state, lastUpdatedBy: undefined };
      }

      return {
        ...state,
        ledgers: state.ledgers.filter(l => l.ledgerId != ledgerId),
        lastUpdatedBy: { id: ledgerId, source },
        error: null
      }
    })
  );